"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupControllerLifeCycleCallbacks = void 0;
var bernie_core_1 = require("bernie-core");
var convert_request_1 = require("./convert-request");
var queryString = require("query-string");
var bernie_logger_1 = require("bernie-logger");
var location_reactor_1 = require("./location-reactor");
var getRequest = function (appData, controller, baseUrl, location) {
    if (baseUrl === void 0) { baseUrl = ''; }
    if (location === void 0) { location = window.location; }
    return (0, convert_request_1.convertRequest)(appData, (0, bernie_core_1.matchRoute)([controller], location.pathname, { baseUrl: baseUrl }), queryString.parse(location.search));
};
var setupControllerLifeCycleCallbacks = function (appData, baseUrl, storeContainer, controller, logger) {
    var callback = function (_a) {
        var prev = _a.prev, next = _a.next;
        return __awaiter(void 0, void 0, void 0, function () {
            var result, prevQuery, prevParams, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        prevQuery = (prev && prev.query) || {};
                        prevParams = (prev && prev.params) || {};
                        return [4 /*yield*/, controller.fetch({
                                query: (next && __assign(__assign({}, next.query), { prevQuery: prevQuery })) || {},
                                params: (next && __assign(__assign({}, next.params), { prevParams: prevParams })) || {},
                                request: getRequest(appData, controller, baseUrl),
                                logger: logger,
                                stores: storeContainer,
                            }, {
                                data: {
                                    stores: storeContainer,
                                },
                                logger: logger,
                            })];
                    case 1:
                        result = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        logger.logEvent(new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.ERROR, 'CONTROLLER_FETCH_ERROR'), error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, result];
                }
            });
        });
    };
    var deactivate = function (hocLocation) {
        if (controller.willDeactivate && typeof controller.willDeactivate === 'function') {
            try {
                controller.willDeactivate({
                    query: hocLocation && hocLocation.query,
                    params: hocLocation && hocLocation.params,
                    request: getRequest(appData, controller, baseUrl, hocLocation),
                    logger: logger,
                    stores: storeContainer,
                }, {
                    data: {
                        stores: storeContainer,
                    },
                    logger: logger,
                });
            }
            catch (error) {
                logger.logEvent(new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.WARN, 'CONTROLLER_DEACTIVATE_ERROR'), error);
            }
        }
    };
    controller.component = (0, location_reactor_1.withLocationReactor)(controller.component, callback, deactivate);
    return controller;
};
exports.setupControllerLifeCycleCallbacks = setupControllerLifeCycleCallbacks;
//# sourceMappingURL=controller-life-cycle.js.map